

































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import ProductTags from '@axCommerce/components/product-tags.vue'

@Component({
  name: 'ProductCardParking',
  components: { ProductTags },
})
export default class ProductCardParkingComponent extends Vue {
  @Prop({ default: null })
  public product!: any

  public name = 'ProductCard-parking'

  @Emit()
  public cardSelected(): any {
    console.log('emit:cardSelected')
    return this.product
  }
}
